<template>
  <div class="main-box">
    <ball></ball>
    <van-nav-bar
      :title="title"
      left-arrow
      left-text="返回"
      @click-left="onClickLeft"
    />
    <div class="gaugesubject_body">
      <div class="gaugesubject_body_title" v-if="showflag">
        <div class="gaugesubject_body_title_index">
          <span style="fontsize: 20px">{{ R_indx + 1 }}</span> /
          <span>{{ subject.length }}</span> 题
        </div>

        <div class="gaugesubject_body_title_btns">
          <div
            :class="index == R_indx ? 'subject_btn_a' : 'subject_btn_b'"
            v-for="(item, index) in subject"
            :key="index"
            @click="btncilck(index, item)"
          >
            {{ item.sortCode }}
          </div>
        </div>
      </div>
      <div class="ans_text" v-if="showflag">答题总分:{{ total }}</div>
      <div class="gaugesubject_body_subject">
        <div
          class="wwww"
          v-if="showflag"
          v-for="(item, index) in subject"
          :key="index"
          :id="'product' + index"
        >
          <div class="subject_name">
            {{ item.sortCode }}.{{ item.question }}
          </div>
          <div class="subject_option" v-if="item.type == 1">
            <van-radio-group v-model="item.value">
              <van-radio
                disabled
                :class="
                  item.value == item1.optionCode
                    ? 'subject_radio_a'
                    : 'subject_radio'
                "
                icon-size="18px"
                v-for="(item1, index1) in item.options"
                :key="index1"
                :name="item1.optionCode"
                >{{ item1.optionCode }}.{{ item1.optionName }}</van-radio
              >
            </van-radio-group>
          </div>
          <div v-else>
            <div class="ans_text">答案：{{ item.value }}</div>
          </div>
        </div>
      </div>
      <div v-if="!showflag" class="res_text">
        <img class="res_img" :src="imgurl + pid + '_' + questionary + '.jpg'" />
      </div>
      <div class="foot_btns">
        <div class="btn_a">
          <van-button plain hairline type="info" @click="showflag = true" block
            >查看答案</van-button
          >
        </div>
        <div class="btn_b">
          <van-button type="info" @click="showflag = false" block
            >查看结果</van-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import setOptions from "@/mixins/setOption";
import Nav from "@/components/nav.vue";
import { Dialog } from "vant";
import backindex from "@/mixins/backindex";
export default {
  mixins: [setOptions, backindex],
  data() {
    return {
      imgurl: "http://static.kmmds.top/static/lks/202105/",
      answer: [],
      showflag: true,
      SR_index: null,
      R_indx: 0,
      total: 0,
      radio: null,
      title: "焦虑状态调查",
      patientId: "",
      subject: [
        {
          id: 0,
          subject: "感觉紧张， 焦虑或急切",
          option: [
            {
              optionname: "完全不会",
              optionid: "A",
              falg: false,
              index: 0,
            },

            {
              optionname: "好几天",
              optionid: "B",
              falg: false,
              index: 1,
            },
            {
              optionname: "一半以上的天数",
              optionid: "C",
              falg: false,
              index: 2,
            },
            {
              optionname: "几乎每天",
              optionid: "D",
              falg: false,
              index: 3,
            },
          ],
        },
        {
          id: 1,
          subject: "不能够停止或控制担忧",
          option: [
            {
              optionname: "完全不会",
              optionid: "A",
              falg: false,
            },

            {
              optionname: "好几天",
              optionid: "B",
              falg: false,
            },
            {
              optionname: "一半以上的天数",
              optionid: "C",
              falg: false,
            },
            {
              optionname: "几乎每天",
              optionid: "D",
              falg: false,
            },
          ],
        },
        {
          id: 2,
          subject: "对各种各样的事情担忧过多。",
          option: [
            {
              optionname: "完全不会",
              optionid: "A",
              falg: false,
            },

            {
              optionname: "好几天",
              optionid: "B",
              falg: false,
            },
            {
              optionname: "一半以上的天数",
              optionid: "C",
              falg: false,
            },
            {
              optionname: "几乎每天",
              optionid: "D",
              falg: false,
            },
          ],
        },
        {
          id: 3,
          subject: "很难放松下来。",
          option: [
            {
              optionname: "完全不会",
              optionid: "A",
              falg: false,
            },

            {
              optionname: "好几天",
              optionid: "B",
              falg: false,
            },
            {
              optionname: "一半以上的天数",
              optionid: "C",
              falg: false,
            },
            {
              optionname: "几乎每天",
              optionid: "D",
              falg: false,
            },
          ],
        },
        {
          id: 4,
          subject: "由于不安而无法静坐。",
          option: [
            {
              optionname: "完全不会",
              optionid: "A",
              falg: false,
            },

            {
              optionname: "好几天",
              optionid: "B",
              falg: false,
            },
            {
              optionname: "一半以上的天数",
              optionid: "C",
              falg: false,
            },
            {
              optionname: "几乎每天",
              optionid: "D",
              falg: false,
            },
          ],
        },
        {
          id: 5,
          subject: "变得容易烦恼或急躁。",
          option: [
            {
              optionname: "完全不会",
              optionid: "A",
              falg: false,
            },

            {
              optionname: "好几天",
              optionid: "B",
              falg: false,
            },
            {
              optionname: "一半以上的天数",
              optionid: "C",
              falg: false,
            },
            {
              optionname: "几乎每天",
              optionid: "D",
              falg: false,
            },
          ],
        },
        {
          id: 6,
          subject: "感到似乎将有可怕的事情发生而害怕。",
          option: [
            {
              optionname: "完全不会",
              optionid: "A",
              falg: false,
            },

            {
              optionname: "好几天",
              optionid: "B",
              falg: false,
            },
            {
              optionname: "一半以上的天数",
              optionid: "C",
              falg: false,
            },
            {
              optionname: "几乎每天",
              optionid: "D",
              falg: false,
            },
          ],
        },
      ],
    };
  },
  components: {
    Nav,
  },
  created() {
    if (this.$route.query) {
      this.pid = this.$route.query.pid;
      this.questionary = this.$route.query.questionary;
      this.patientId = this.$route.query.patientId;
      this.title = this.$route.query.name;
      // console.log(this.medCardNo)
    }
    // this.queryquestioninfobyid();
    this.querymentaltestresultinfo();
  },
  methods: {
    async queryquestioninfobyid() {
      try {
        this.$showLoad();
        let url = "/gauge/queryquestioninfobyid";
        let data = {
          id: this.questionary,
        };
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          data,
          (data) => {
            this.$hideLoad();
            this.subject = data.data.data.data;
            this.subject.forEach((element) => {
              element["value"] = "";
            });
            this.subject.forEach((element) => {
              this.answer.forEach((element1) => {
                if (element1.questionId == element.id) {
                  element["value"] = element1.result;
                  element.options.forEach((item) => {
                    if (item.optionCode == element1.result) {
                      this.total += item.score;
                    }
                  });
                }
              });
            });
          }
        );
      } catch (error) {}
    },
    async querymentaltestresultinfo() {
      try {
        this.$showLoad();
        let url = "/gauge/queryquestionresultinfo";
        let data = {
          patientId: this.pid,
          questionaryId: this.questionary,
        };
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          data,
          (data) => {
            this.$hideLoad();
            // console.log(data);
            //  this.answer=data.data.data.data['0'].result
            //  this.answer=this.answer.split(",")
            this.answer = data.data.data.data;
            this.queryquestioninfobyid();
          }
        );
      } catch (error) {}
    },

    btncilck(index, item) {
      document.getElementById("product" + index).scrollIntoView(true);
      this.R_indx = index;
    },
    goconfUser() {
      this.$router.push("/patient_card_confUser_C");
    },
    //
    onClickLeft() {
      this.$router.go(-1);
    },
    getyDay(date) {
      date.setTime(date.getTime());
      date =
        date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
      return date;
    },
  },
};
</script>

<style lang="scss" scoped>
.main-box {
  width: 100vw;
  height: 100vh;
  background-color: white;
  font-family: "SimSun";
  .ans_text {
    font-size: 18px;
    margin-left: 2vw;
  }
  .gaugesubject_body {
    display: flex;
    flex-direction: column;
    width: 100vw;
    max-height: 100vh;
    .gaugesubject_body_title {
      background-color: #5b8df6;
      height: 15vh;
      .gaugesubject_body_title_index {
        color: white;
        line-height: 8vh;
        margin-left: 2vw;
        font-size: 15px;
      }
      .gaugesubject_body_title_btns {
        display: flex;
        height: 10vh;
        width: 95vw;
        overflow-x: auto;
        .subject_btn_a {
          min-width: 8vw;
          height: 5vh;
          border: 1px solid white;
          color: white;
          line-height: 5vh;
          text-align: center;
          margin-left: 3vw;
        }
        .subject_btn_b {
          min-width: 8vw;
          height: 5vh;
          border: 1px solid white;
          color: #5b8df6;
          background-color: white;
          line-height: 5vh;
          text-align: center;
          margin-left: 3vw;
        }
      }
    }
    .res_text {
      font-size: 16px;
      color: #666;
      line-height: 4vh;
      max-height: 80vh;
      width: 95vw;
      margin: 0px auto;
      overflow-y: auto;
      .res_img {
        width: 100vw;
        max-height: 100vh;
      }
      .res_text_title {
        text-align: center;
        font-size: 18px;
      }
      .res_text_cont {
        text-indent: 2em;
      }
    }
    .gaugesubject_body_subject {
      width: 100vw;
      max-height: 70vh;
      overflow-y: auto;

      .wwww {
        width: 100vw;
        max-height: 100vh;
        .subject_name {
          margin-left: 3vw;
          width: 95%;
          font-size: 16px;
          margin-bottom: 2vh;
        }
        .subject_option {
          margin-left: 3vw;
          width: 95%;
          font-size: 16px;

          .subject_radio {
            margin-bottom: 1vh;
            color: black;
          }
          .subject_radio_a {
            background: #b9f6d2;
            opacity: 0.9;
          }
        }
      }
    }
    .foot_btns {
      width: 100vw;
      max-height: 20vh;
      margin: 0px auto;
      display: flex;
      flex-direction: row;
      .btn_a {
        margin-left: 3vw;
        width: 45vw;
      }
      .btn_b {
        margin-left: 3vw;
        width: 45vw;
      }
    }
  }
  .van-radio__label--disabled {
    color: black;
  }
}
</style>